<!-- eslint-disable vue/no-v-html -->
<template>
	<Form :validation-schema="valSchema" @submit="butNext">
		<div>
			<div class="container-sm prodMain">
				<div class="row align-items-start">
					<div class="col-3"></div>

					<div class="col-1">&nbsp;</div>

					<div class="col-8">
						<div class="pageTitle">
							<img
								id="iconShoppingCart"
								class="img-fluid"
								src="images\shoppingCartIcon.png"
								onerror="this.onerror=null; this.src='images/placeholder_CompanyLogo.png'"
							/>
							<span class="spanTitle"
								>Terms &amp; Conditions</span
							>
						</div>
					</div>
				</div>
			</div>

			<div class="container-sm prodMain">
				<div class="row align-items-start">
					<div class="sectionTitle">Terms &amp; Conditions</div>
				</div>
			</div>

			<div class="container-sm prodMain">
				<div class="row">
					<div class="panel">
						<div class="panel-body default-panel">
							<!--CTL Terms-->
							<div v-if="!isOlLms" class="termsList">
								<TermCopyCTL></TermCopyCTL>
							</div>

							<!--OL Terms-->
							<div v-if="isOlLms" class="termsList">
								<TermCopyOL></TermCopyOL>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="container-sm prodMain">
				<div class="row">
					<div class="col-sm-8"></div>
					<div class="col-sm-4">
						<div class="form-group">
							<div class="checkbox">
								<label
									for="chkAgreeTerms"
									class="control-label"
								>
									I agree to these Terms &amp; Conditions
								</label>
								<input
									id="chkAgreeTerms"
									type="checkbox"
									css="form-control"
									@click="chkActiveTerms_OnClick($event)"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="pageMsg" class="container-sm prodMain">
				<div class="row">
					<!-- // eslint-disable-next-line vue/no-v-html -->
					<div class="alert alert-warning" v-html="pageMsg"></div>
				</div>
			</div>

			<div class="container-sm prodMain">
				<div class="row footCommandRow">
					<div class="col-sm-3">
						<a
							href="#"
							class="btn btn-primary butCheckOut"
							@click.prevent="butBack()"
						>
							Back to Customer Details
						</a>
					</div>

					<div class="col-sm-6 d-none d-sm-block"></div>

					<div class="col-sm-3">
						<!-- <a href="#" class="btn btn-primary butCheckOut"  @click.prevent="butNext()">Payment Details</a> -->
						<button
							type="submit"
							class="btn btn-primary butCheckOut"
						>
							Payment Details
						</button>
					</div>
				</div>
			</div>
		</div>
	</Form>
</template>

<script>
// import {
// 	CustomerDetail,
// 	CustomerDetailsUtils,
// } from "@/components/classes/CustomerDetail.js";

// import { Field, Form, ErrorMessage } from "vee-validate";
import { Form } from "vee-validate";
import * as yup from "yup";

// import { configure } from "vee-validate";
// // import { useIsFormValid } from 'vee-validate';
// import debounce from "lodash/debounce";

// let userControllerURL = ""; // "http://localhost:64006/store/api/user/";

import {
	Cart,
	// CartItem,
	// Coupon,
	// TaxRate,
	CartUtils,
} from "@/components/classes/Cart.js";

import TermCopyCTL from "@/components/subs/TermCopyCTL.vue";
import TermCopyOL from "@/components/subs/TermCopyOL.vue";
import * as Sentry from "@sentry/vue";

export default {
	name: "Terms",
	// termCTLComponent: "TermCopyCTL",
	components: {
		// Field,
		Form,
		// ErrorMessage,
		TermCopyCTL,
		TermCopyOL,
	},
	emits: ["eventname"],

	setup() {
		// let test = "";
	},
	data() {
		const valSchema = yup.object({
			// email: yup.string().required().email(),
			// password: yup.string().required().min(8),
			// FirstName: yup.string().required().label("First Name"),
			// LastName: yup.string().required().label("Last Name"),
			// Address: yup.string().required().label("Address"),
			// AptSuite: yup.string().label("Apt/Suite #"), //not required
			// City: yup.string().required().label("City"),
			// PostalCode: yup.string().required().label("Zip/Postal Code"),
			// Country: yup.string().required().label("Country"),
			// ProvState: yup.string().required().label("State/Province"),
			// Phone: yup.string().required().label("Phone"),
			// Password: yup
			// 	.string()
			// 	.required()
			// 	.label("Password")
			// 	.matches(
			// 		/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{10,}$/,
			// 		"Password must contain 1 number, 1 Uppercase letter, 1 Lowercase letter, 1 symbol and be at least 10 characters long."
			// 	),
			// ConfirmPassword: yup
			// 	.string()
			// 	.required()
			// 	.label("Confirm Password")
			// 	.oneOf([yup.ref("Password")], "Passwords do not match"),
			// Email: yup.string().required().email().label("Email"),
		});

		return {
			agreedTerms: false,
			pageMsg: "",
			isOlLms: false,
			valSchema,
			// termCTLComponent: "TermCopyCTL",
		};
	},

	watch: {},

	//,
	mounted() {
		try {
			let newCart = new Cart();
			let cartUtils = new CartUtils();

			if (localStorage.getItem("cart")) {
				// try {
				newCart = cartUtils.reviveCartObj();
				var ci = newCart.CartItems[0];

				if (ci.product.productLms.brand.id == 1) {
					this.isOlLms = true;
				}
			}
		} catch (e) {
			console.log("Terms mounted", e);
			//add sentry catch error line here
			Sentry.captureException(e);
		}
	},

	methods: {
		chkActiveTerms_OnClick: function (event) {
			try {
				if (event.target.checked) {
					this.agreedTerms = true;
				} else {
					this.agreedTerms = false;
				}
			} catch (e) {
				console.log("Terms methods chkActiveTerms.onclick", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		butBack() {
			try {
				this.$emit("eventname", "CustomerDetails");
			} catch (e) {
				console.log("Terms methods butBack", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},

		butNext() {
			try {
				let ctx = this;
				// console.log("this.customerDetail", this.customerDetail);

                if (this.agreedTerms) {
                    console.log("loading Payment component"); 
					ctx.$emit("eventname", "Payment");
				} else {
					ctx.pageMsg =
						"Please click the checkbox to agree and continue.";
				}
			} catch (e) {
				console.log("Terms methods butNext", e);
				//add sentry catch error line here
				Sentry.captureException(e);
			}
		},
		// updateparent(variable) {
		// 	this.termCTLComponent = variable;
		// },
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.formDiv {
	padding-bottom: 30px;
}

.prodMain {
	margin-bottom: 50px;
	max-width: 1000px;
}

.prodMain .pageTitle {
	font-size: 30px;
	margin-bottom: 0px;
}
.brandLogoWrapper {
	text-align: center;
}
#brandLogo {
	margin-bottom: 20px;
	/* min-height:100px; */
	/* width:90px;
    height:90px;
    margin-right:auto;
    margin-left: auto; */
	width: 100%;
	max-width: 90px;
}
#prodImgThumnb {
	margin-bottom: 50px;
	min-height: 100px;
	width: 240px;
	height: 260px;
}
.prodMain .prodTitle {
	font-size: 20px;
	margin-bottom: 30px;
	border-bottom: 1px grey solid;
}

.cartLine {
	font-size: 16px;
}
.cartLine .label {
	font-weight: 400;
}
.cartLine .fee {
	text-align: right;
}
.floatSwitch {
	float: left;
}
.prodMain .label {
	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
}
.prodPlanType {
	margin-bottom: 20px;
	/* border:1px red solid; */
}
.prodPlanType div {
	padding: 0px;
	/* padding-left: 12px; */
	/* border:1px red solid;  */
}
.planTypeLabel {
	margin-left: 10px;
}
.prodDesc {
	margin-bottom: 20px;
}
.prodFee {
	margin-bottom: 20px;
}

.prodCoupon {
	margin-bottom: 20px;
}
.cartLine {
	margin-bottom: 10px;
	border-top: 1px #ddd solid;
	padding-top: 10px;
}
.billAnnual {
	font-size: 12px;
	display: block;
	clear: both;
	color: rgb(90, 89, 89);
}
.feeBlock {
	display: block;
	clear: both;
}
.footCommandRow {
	border-top: 1px #ddd solid;
	margin-top: 40px;
	padding-top: 20px;
	text-align: right !important;
}
a.butRemove {
	font-size: 8px;
	padding: 2px;
}

.form-switch .form-check-input {
	/* width: 2em; */
	margin-left: 0em;
}
.form-check .form-check-input {
	/* float: left; */
	margin-left: 0;
}
/* .planTypeLabel {
   
} */

.btn {
	margin-bottom: 20px;
}

.btn-primary,
.btn-primary:hover {
	background-color: #a9cf3c;
	border-color: #a9cf3c;

	font-weight: 600;
	font-family: Lato Bold, Arial, Helvetica, sans-serif;
}

.butCheckOut,
.butCheckOut:hover {
	width: 100%;
}

.row {
	--bs-gutter-x: 0rem;
}
.iconShoppingCart {
	padding: 0px;
	margin: 0px;
	margin-right: 10px;
}
.spanTitle {
	padding-left: 20px;
}
.colRemoveButton {
	text-align: right;
}
.discountDisc {
	font-size: 12px;
	color: #a9cf3c;
	font-style: italic;
}
.discAmt {
	color: #a9cf3c;
}
.alertVal {
	display: block;
	margin-top: 5px;
	padding: 5px;
	padding-left: 10px;
	padding-right: 10px;
}
.sectionTitle {
	font-size: 20px;
	border-bottom: 1px #ddd solid;
	padding-bottom: 5px;
	margin-bottom: 20px;
	margin-top: 40px;
	color: #a9cf3c;
}
form label span {
	display: block;
	font-size: 12px;
	color: #aaa;
}

.emailChecker {
	height: 40px;
	display: block;
	position: relative;
	padding-left: 35px;
	padding-top: 5px;
}
.emailChecker img {
	width: auto;
	height: 100%;
	left: -10px;
	position: absolute;
	top: 0px;
	float: left;
}

.checkbox {
	/* border: 1px red solid; */
	display: block;
	/* width: 30%;
	float: right; */
}
.checkbox #chkAgreeTerms {
	float: right;
	display: block;
	margin: 0;
	padding: 0;
	margin-top: 6px;
	transform: scale(1.8);
}

.checkbox label {
	float: right;
	margin: 0;
	padding: 0;
	margin-left: 20px;
	display: block;
}

.panel {
	margin: 0px;
	padding: 20px;
	margin-top: 10px;
	margin: 0px;
	border: 1px #ddd solid;
	border-radius: 10px;
	/* height: 400px; */
}

.termsList {
	margin: 0px;
	padding: 20px;
	margin-top: 10px;
	margin: 0px;
	border: 0px #ddd solid;
	border-radius: 10px;
	/* height: 70%; */
	height: 400px;
	overflow: scroll;
}

.termsList ol {
	margin: 0px;
	padding: 0px;
	margin-top: 10px;
	margin: 15px;
}
.termsList ol li {
	margin: 0px;
	padding: 0px;
	margin-bottom: 20px;
}
.termsList ol li ol {
	margin: 0px;
	padding: 0px;
	margin-top: 20px;
	margin-left: 35px;
	list-style-type: lower-alpha;
}
</style>
